// extracted by mini-css-extract-plugin
export var bg = "styles-module--bg--7ab04";
export var bgWrapper = "styles-module--bgWrapper--d60a0";
export var content = "styles-module--content--8bd63";
export var wrapper = "styles-module--wrapper--0a9ff";